import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const PACIFIC_TZ = 'America/Los_Angeles';

export const convertToPacificDate = (utcDateString) => {
  return dayjs.tz(utcDateString, 'America/Los_Angeles');
};

export const getPostDate = (post) => convertToPacificDate(post.webinarUTCDate);

export const getPacificNow = () => dayjs().tz(PACIFIC_TZ);

const sortPostsLatestToNewest = (posts) =>
  posts.sort((a, b) => getPostDate(b).valueOf() - getPostDate(a).valueOf());

const sortPostsNewestToLatest = (posts) =>
  posts.sort((a, b) => getPostDate(a).valueOf() - getPostDate(b).valueOf());

export const getFeaturedPost = (posts) => {
  const sortedPosts = sortPostsNewestToLatest(posts);
  const currentDateTime = getPacificNow();
  const featuredUpcomingPost = sortedPosts.filter((post) => {
    const postDate = getPostDate(post);
    return postDate.isAfter(currentDateTime);
  });

  const onDemandPost = getOnDemandPosts(posts)[0];

  return featuredUpcomingPost[0] || onDemandPost;
};

export const getUpcomingPosts = (posts) => {
  const now = getPacificNow();
  const featuredPost = getFeaturedPost(posts);

  const sortedUpcomingPosts = sortPostsNewestToLatest(posts).filter((post) => {
    const postDate = getPostDate(post);
    const plus30 = postDate.add(30, 'minute');

    return plus30.isAfter(now);
  });

  return sortedUpcomingPosts.filter((post) => post !== featuredPost);
};

export const getOnDemandPosts = (posts) => {
  const minus30 = getPacificNow().subtract(30, 'minute');

  return sortPostsLatestToNewest(posts).filter((post) => getPostDate(post).isBefore(minus30));
};

export const isLive = (post) => {
  const now = getPacificNow();
  const postDate = getPostDate(post);
  const plus30 = postDate.add(30, 'minute');

  return postDate.isBefore(now) && now.isBefore(plus30);
};

export const isUpcomingPost = (post) => getPostDate(post).isAfter(getPacificNow());

export const filterPostsFromSplashAndToolbox = (posts) => {
  return posts.filter((post) => post.removeFromSplashPage !== true);
};

export const removeFeatureAndSubscribePosts = (posts) => {
  const featuredPost = getFeaturedPost(posts);
  return posts.filter((post) => post.id !== featuredPost.id && post.onDemandPage);
};
